import * as React from 'react';
import { Grid } from '@mui/material';
import { TrashIcon, UploadIcon } from 'assets/icons';
import './index.scss';

import { IconLoadingButton } from '../../molecules/custom-button';
import ContentMediaView from '../content-media-view';

interface FileItemPreviewProps {
  currentContentUrl: string,
  currentMediaType: string,
  removeMediaItem?: () => void,
  uploadNew?: () => void,
}

const FileItemPreview = ({
  currentContentUrl, currentMediaType, removeMediaItem, uploadNew,
}: FileItemPreviewProps) => {
  const handleUploadNew = () => {
    if (uploadNew) {
      uploadNew();
    }
  };

  const handleRemove = () => {
    if (removeMediaItem) {
      removeMediaItem();
    }
  };

  return (
    <Grid container justifyContent="flex-start" alignItems="center">
      <Grid item xs="auto" className="grid-item">
        <div style={{ height: currentMediaType === 'image' ? '6rem' : '8rem', width: currentMediaType === 'image' ? '6rem' : '14rem' }}>
          <ContentMediaView url={currentContentUrl} mediaType={currentMediaType} fileName={`${currentContentUrl?.split('/').pop()}`} />
        </div>
      </Grid>
      <Grid item xs="auto" className="grid-item">
        <IconLoadingButton
          startIcon={<UploadIcon sx={{ color: 'primary.main' }} />}
          onClick={handleUploadNew}
        >
          Upload new
        </IconLoadingButton>
      </Grid>
      <Grid item xs="auto" className="grid-item">
        <IconLoadingButton
          startIcon={<TrashIcon sx={{ color: 'primary.main' }} />}
          onClick={handleRemove}
        >
          Remove
        </IconLoadingButton>
      </Grid>
    </Grid>
  );
};

FileItemPreview.defaultProps = {
  removeMediaItem: null,
  uploadNew: null,
};

export default FileItemPreview;
